import React from 'react';
import { Star, MapPin } from 'lucide-react';
import { useTranslation } from '../../i18n';

/**
 * Featured hero for the Stories discovery screen — 1- or 2-up large cover cards
 * with a gradient scrim. Mirrors the Growth Explore FeaturedHero.
 */
export default function MovementHero({ stories, onOpen }) {
  const { t } = useTranslation('movement');
  if (!stories || stories.length === 0) return null;
  const shown = stories.slice(0, 2);

  return (
    <div className={`ms-featured-hero${shown.length > 1 ? ' ms-featured-hero--duo' : ''}`}>
      {shown.map(story => (
        <button
          type="button"
          key={story.id}
          className={`ms-featured-card${story.coverImage ? '' : ' ms-featured-card--noimg'}`}
          onClick={() => onOpen(story.id)}
          aria-label={story.title || t('sectionFeatured')}
        >
          {story.coverImage && <img className="ms-featured-img" src={story.coverImage} alt="" loading="lazy" />}
          <div className="ms-featured-scrim" />
          <div className="ms-featured-content">
            <span className="ms-featured-badge"><Star size={11} strokeWidth={2.5} /> {t('sectionFeatured')}</span>
            {story.title && <h2 className="ms-featured-title">{story.title}</h2>}
            {story.excerpt && <p className="ms-featured-excerpt">{story.excerpt}</p>}
            {story.location && (
              <span className="ms-featured-loc"><MapPin size={12} strokeWidth={2.25} /> {story.location}</span>
            )}
          </div>
        </button>
      ))}
    </div>
  );
}
